import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_FORMATS } from '../format/format';
import { Moment } from 'moment';

@Component({
  selector: 'app-month-date-picker',
  templateUrl: './month-date-picker.component.html',
  styleUrls: ['./month-date-picker.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class MonthDatePickerComponent implements OnInit {
  @Input() label: string;
  @Input() defaultDate: Date;
  @Input() hint: string;

  @Output() monthChosen: EventEmitter<Moment> = new EventEmitter<Moment>();

  constructor() { }

  ngOnInit(): void { }

  chosenMonthHandler(event, datepicker: any) {
    this.defaultDate = event;
    this.monthChosen.emit(event);
    datepicker.close();
  }
}
